import { createSlice } from "@reduxjs/toolkit";

const persistedUser = JSON.parse(localStorage.getItem("user")) || null;
const persistedRights = JSON.parse(localStorage.getItem("rights")) || null;
const persistedToken = localStorage.getItem("token") || null;

const initialState = {
  status: false,
  loggedIn: null,
  userData: persistedUser,
  token: persistedToken,
  rights: persistedRights,
  dbStatus: {},
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    fetchMe: (state, action) => {
      state.loggedIn = action.payload;
    },
    adminLogin: (state, action) => {
      state.userData = action.payload;
      state.rights = action.payload.myRight;
      state.token = action.payload.token;
    },
    checkDbConnect: (state, action) => {
      state.dbStatus = action.payload;
    },
    removeToken: (state, action) => {
      state.token = null;
      state.userData = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("rights");
    },
  },
});

export default AuthSlice.reducer;

export const { fetchMe, adminLogin, checkDbConnect, removeToken } = AuthSlice.actions;
